<template>
  <div v-if="isLocal" class="c-client-selection">
    <button type="button" class="c-button c-button--ghost c-button--small"
            :aria-label="$t('interface.clientSelection')" @click="open = !open">
      {{ $t('interface.client.legacy') }}
    </button>
    <div v-if="open" class="c-client-selection__menu">
      <strong>{{ $t('interface.clientSelection') }}</strong>
      <p>{{ selected ? $t('interface.client.' + selected) : $t('interface.client.checking') }}</p>
      <button v-if="canControl" type="button" class="c-button c-button--small c-button--secondary"
              :disabled="pending" @click="switchClient">
        {{ $t('interface.switchToNew') }}
      </button>
      <p v-if="error" role="alert" class="c-form--error">{{ $t('interface.switchFailed') }}</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import config from 'client/config'

export default {
  name: 'clientSelectionStatus',
  data() {
    return { selected: null, open: false, pending: false, error: false, timer: null }
  },
  computed: {
    isLocal() { return this.$store.state.environment.local },
    canControl() {
      if (!this.$store.state.user.instance) return false
      const roles = this.$store.state.user.roles
      return roles.general === 'admin' || roles.event === 'organiser'
        || roles.organisation === 'organiser' || roles.organisation === 'admin'
    },
  },
  watch: {
    isLocal: {
      immediate: true,
      handler(local) { if (local) this.refresh() },
    },
  },
  beforeDestroy() { clearTimeout(this.timer) },
  methods: {
    refresh() {
      Vue.http.get(config.root + '/client-selection').then(response => {
        this.selected = response.data.client
        this.error = false
        if (response.data.mode === 'local' && this.selected !== 'legacy') {
          window.location.assign('/')
          return
        }
      }, () => { this.error = true }).then(() => {
        if (this.isLocal) this.timer = setTimeout(this.refresh, 5000)
      })
    },
    switchClient() {
      if (!this.canControl || this.pending) return
      this.pending = true
      this.error = false
      Vue.http.post(config.root + '/client-selection', { client: 'nuxt' }).then(() => {
        window.location.assign('/')
      }, () => {
        this.error = true
        this.pending = false
      })
    },
  },
}
</script>

<style scoped>
.c-client-selection { position: relative; display: inline-block; }
.c-client-selection__menu {
  position: absolute; right: 0; top: 100%; z-index: 1000; width: 250px;
  padding: 1rem; background: white; color: #222; border: 1px solid #ddd;
  box-shadow: 0 2px 8px rgba(0,0,0,.15);
}
</style>
